import React, { useState } from 'react';
import styles from './Home.module.css';
import image1 from '../../Images/1.png';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import Spinner from 'react-bootstrap/Spinner';

const Home = () => {
  // State to toggle between showing all cards or just the first 8
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate(); // Import navigate hook
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { Categories, loading } = useSelector((state) => state.CategoriesSlice);

console.log("Categories",Categories)
  // Show either first 8 or all cards based on the state
  const safeCategories = Array.isArray(Categories) ? Categories : [];
  const cardsToDisplay = showAll ? safeCategories : safeCategories?.slice(0, 8);


  
  const onSubmit = (card) => {
    console.log("card", card);
    navigate('/services',); // Navigate to /services
    localStorage.setItem("card", JSON.stringify(card));

  }

  return (
    <>
   {loading ? <div style={{display:"flex", justifyContent:"center"}}>

    <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
   </div>:
   <div>
   {Categories && Categories?.length > 0 ? <div>
    <div className={styles.cardContainer}>
      {cardsToDisplay.map((card, index) => (
        <div key={index} className={styles.card} onClick={() => { onSubmit(card) }}>
          <img src={card?.cats_IMG ? `https://reservation.ladycaresa.com/public/uploads${card.cats_IMG}` : image1} alt={card.cats_nam.trim()} className={styles.cardImage} />
          <div className={styles.cardLabel}>
          <span>
  {currentLanguage === "ar"
    ? card.cats_nam.trim() // Arabic branch name
    : card.cats_enm.trim() || card.cats_nam.trim() // English branch name (fallback to Arabic if empty)
  }
</span>

          </div>
        </div>
      ))}
      {/* Button to toggle between Show More / Show Less */}
      <div 
        className={styles.showMoreButton} 
        onClick={() => setShowAll(!showAll)}
        style={{display:"flex", justifyContent:"end", width:"100%", color:"#0066BA", textDecoration:"Underline", cursor:"pointer", margin:"0 10px"}}
      >
       {Categories.length > 8 && (
  <span>
    {showAll ? t('showLess') : t('more')}
  </span>
)}
      </div>

    </div>

    <div style={{width:"100%", height:"2px", background:"#333"}}></div>
  
    </div> 
  :  <div style={{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      fontSize:"28px",
      fontWeight:"900",
      margin:"70px"
    }}>{t('ThereAreNoCategoriesAvailableInThisBranch')} </div>  
    }
    
    </div>}
    </>
  );
};

export default Home;
